import {ErrorComponent} from '@refinedev/mui';
import {Route, Routes as RouterRoutes} from 'react-router';

import {Home} from '@pages/nemesis';

export const Routes = () => {
  return (
    <RouterRoutes>
      <Route index element={<Home />} />
      <Route path="*" element={<ErrorComponent />} />
    </RouterRoutes>
  );
};
